import React from 'react';

/** Passthrough — auth/role is handled on the server. Avoids stale HMR / old App bundles referencing an undefined component. */
export default function ResellerRoute({ children }) {
  return children;
}
